import { __decorate, __metadata } from "tslib";
import { ApplicationContextToken } from '@1inch-community/core/application-context';
import { lazyProvider } from '@1inch-community/core/lazy';
import { css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { getContext } from './context';
let GlobalApplicationContextElement = class GlobalApplicationContextElement extends LitElement {
    static { this.tagName = 'global-application-context'; }
    static { this.styles = css `
    :host {
      display: flex;
      flex-direction: column;
      height: 100%;
    }
  `; }
    constructor() {
        super();
        lazyProvider(this, { context: ApplicationContextToken, initialValue: getContext() });
    }
    render() {
        return html `<slot></slot>`;
    }
};
GlobalApplicationContextElement = __decorate([
    customElement(GlobalApplicationContextElement.tagName),
    __metadata("design:paramtypes", [])
], GlobalApplicationContextElement);
export { GlobalApplicationContextElement };
//# sourceMappingURL=global-application-context.element.js.map